import React from 'react';
import Main from '../components/Home/Home';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

function Home() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default Home;
